import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let tab = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
  })

  return useMemo(() => {
    if (!rdata) return rdata

    return tab?.selected?.filters || rdata
  }, [tab?.selected?.filters, rdata])
}
